/**
 * Wohin es nach der Anmeldung geht: immer ein Pfad INNERHALB der Oberfläche.
 *
 * Das Ziel stammt aus der Adresse, mit der jemand gekommen ist. Zwei Dinge
 * dürfen daraus nicht werden:
 *
 * 1. Ein Pfad mit mehreren Schrägstrichen am Anfang (`//?client=…`, etwa aus
 *    einem Lesezeichen `http://leif//?client=…`). Der Browser liest das als
 *    Rechnernamen, und die Navigation bricht mit „Failed to execute
 *    'replaceState'" ab. Die Anmeldung hat dann zwar geklappt, die Seite
 *    zeigt aber einen Fehler statt der Oberfläche.
 * 2. Eine fremde Adresse. Nach dem SSO-Rücksprung wird das Ziel als ganze
 *    Seite geladen; ein `//fremd.example` wäre dort eine Weiterleitung nach
 *    draußen.
 */
export function internesZiel(roh: unknown, ersatz = "/logs"): string {
  if (typeof roh !== "string") return ersatz;
  // Auch der Rückstrich zählt: Browser behandeln `/\host` wie `//host`.
  const pfad = roh.trim().replace(/^[/\\]+/, "/");
  if (!pfad.startsWith("/")) return ersatz;
  // Zurück auf die Anmeldeseite wäre eine Schleife.
  if (/^\/login([/?#]|$)/.test(pfad)) return ersatz;
  return pfad;
}
